import React from "react";

// El mismo div de spinner estaba copiado carácter por carácter en
// PalabraDelDia, EvangeliosAnteriores y Home.
//
// `label` no es decorativo: sin él un lector de pantalla no anuncia nada
// mientras la página carga. Se oculta a la vista pero se lee en voz alta.
export default function Spinner({ label = "Cargando", className = "" }) {
  return (
    <div role="status" className={`inline-flex items-center gap-3 ${className}`}>
      <div
        aria-hidden="true"
        className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin"
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}
